import { hideSpinner, showSpinner } from './../actions/spinners.actions';
import { createFeatureSelector, createReducer, on } from "@ngrx/store";

export interface SpinnerState {
    status: boolean;
}

const initState: SpinnerState = {
    status: false
} ;

export const spinnersReducer = createReducer(
    initState,
    on(showSpinner, (state) =>( {...state, status: true})),
    on(hideSpinner, (state) =>( {...state, status: false})),
);

export const selectSpinnerState = createFeatureSelector<SpinnerState>('spinnerState');
